import classNames from 'classnames';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import withInspector from 'fulogics-ui-web/dist/layout/inspector/hoc/withInspector';
import DraftClosedDeadlineColumnSchema from './DraftClosedDeadlineColumnSchema';
import enOrderState from '../../../api/enums/enOrderState';
import styles from './DraftClosedDeadline.module.scss';
import { formatDate } from 'fulogics-ui-core';

const DraftClosedDeadlineColumn = (props: DraftClosedDeadlineColumnProps) => {
    const { t } = useTranslation('DraftClosedDeadlineColumn');

    let copy: string = '';
    let noData = t('noData');
    if (props.data?.state == enOrderState.Draft) copy = t('planned');

    if (
        props.data?.state == enOrderState.SendingInProgress ||
        props.data?.state == enOrderState.SentToWMS ||
        props.data?.state == enOrderState.SentToWMSAndTMS ||
        props.data?.state == enOrderState.InProgress
    ) {
        copy = t('transferredToDT');
    }

    return (
        <div
            className={classNames(styles.container, props.className, {
                [styles.errorContainer]: !props.data?.validationResult?.isValid,
            })}
        >
            {props.data?.validationResult?.isValid ? (
                <div>{!!props.data?.draftCloseDeadline && copy}</div>
            ) : (
                <div>{t('error')}</div>
            )}
            <div>
                {!!props.data?.draftCloseDeadline
                    ? formatDate(props.data?.draftCloseDeadline, 'DD.MM.yyyy - HH:mm')
                    : noData}
            </div>
        </div>
    );
};

export type DraftClosedDeadlineColumnProps = {
    data?: DraftClosedDeadlineColumnData;
} & DraftClosedDeadlineColumnDisplayOptions;

export default withInspector<DraftClosedDeadlineColumnProps>(
    DraftClosedDeadlineColumn,
    DraftClosedDeadlineColumnSchema
);

export class DraftClosedDeadlineColumnDisplayOptions {
    className?: string;
}

export type DraftClosedDeadlineColumnData = {
    draftCloseDeadline?: Date;
    state?: enOrderState;
    validationResult?: {
        isValid?: boolean;
    };
};

export const DraftClosedDeadlineColumnDataKeys = [];
